import { render, staticRenderFns } from "./goodsDate.vue?vue&type=template&id=4e4064ab"
import script from "./goodsDate.vue?vue&type=script&lang=js"
export * from "./goodsDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports